import type { TextPropView } from '@consta/uikit/Text'
import { EllipsingText } from '@library/components'
import type { FC } from 'react'

type SettingLabelProps = {
  size?: 'xs' | 's' | 'm' | 'l'
  text?: string
  view?: TextPropView
}

export const SettingLabel: FC<SettingLabelProps> = ({ text, size = 'xs', view = 'secondary' }) => {
  return (
    <EllipsingText view={view} size={size}>
      {text}
    </EllipsingText>
  )
}
